import { Box, Typography } from '@material-ui/core';
import React, { useState } from 'react';
import useStyles from './styles';
import {  Person } from '@material-ui/icons';
import ActivationListTable from './components/ActivationListTable';
import './styles.css';
import CustomButton from './components/CustomButton';
import PaymentForm from './components/PaymentForm';

export default function UserManager() {
    const classes = useStyles();
    const [searchValue,setSearchValue] = useState('');
    const [userCount,setUserCount] = useState(0);
    const [openModal,setOpenModal] = useState(false)
    
  const onChangeSearchValue = (value)=>{
        setSearchValue(value);
    }

    const handleModal =() =>{

        setOpenModal(!openModal);
    }
    
    return(
        <Box m={2}>
            <div className="pageHeading"> 
               <Typography variant="h4" className={classes.heading}>
                Activation List
               </Typography>
               <div className="buttonsWrap">    
              
               <div className="buttonWrapperContainer">
               {<CustomButton action={handleModal}  buttonText={'Payment'} buttonColor={'#f5c542'} buttonIcon={Person} textColor={'#000000'}/>}
               
               </div>
            </div>
            </div>
            <ActivationListTable searchValue={searchValue} userCountHandler={(a)=> setUserCount(a)}/> 
           

            <PaymentForm open={openModal} handleClose={handleModal}/>
        </Box>
    )
}